<template>
	<div v-bind:class="['form', { success }]">
		<h3>
			Choose a Password
			<!-- <router-link :to="loginSecondary">{{ loginSecondaryText }}</router-link> -->
		</h3>
		<!-- Password input -->
		<PasswordInput
				title="Enter Password"
				:autofocus="false"
				v-model="newPassword"
				info="minimum 8 characters">
		</PasswordInput>
		<PasswordInput
			title="Re-enter Password"
			:autofocus="false"
			v-model="confirmPassword"
			:error="setPasswordError">
		</PasswordInput>

		<p v-if="! showViews" class="message">
			{{ getLoadingText }}
		</p>
		<!-- Login button -->
		<SubmitButton
			:disabled="setPasswordDisabled"
			:loading="setPasswordLoading"
			v-on:click="setPassword">
			{{ resetActionText }}
		</SubmitButton>
	</div>
</template>

<script>
import AuthForm from '.'

export default {
	name: 'reset-password-form',
	extends: AuthForm,

	props: {
		logout: {
			type: Boolean
		}
    },
    data() {
        return {
			invalid: false,
			invalidCode: false,
			showViews: true,
			resettingPassword: false
        }
	},
    mounted() {
        if (this.query && this.query.token) {
            this.verifyReset({
                token: this.query.token
            })
            .then((result) => {
				this.showViews = true
                if (! result.set_password) {
                    this.invalidCode = true
                    return
                }
                else
                    return this.$router.push({ name: 'reset-password'})
            })
            .catch((err) => {
				console.log(err)
				this.showViews = true
                if (err.code == "InvalidToken")
					this.invalidCode = true
				return this.$router.push({ name: 'reset-verify' })
            })
        }
    },
	methods: {
		resetAction() {
			this.showViews = false
			this.resettingPassword = true

            if (this.password.length < 6) {
                this.invalid = true
                return
            }
            return this.resetPassword({
                email: this.authenticatedEmail,
                reset_token: this.authenticatedCode ? this.authenticatedCode : this.authenticatedResetToken.reset_token,
                password: this.password,
                device: "device id"
            })
            .then((result) => {
                this.email = this.authenticatedEmail
                return this.login()
            })
            .catch((err) => {
                console.log(err)
            })
		}
	},

	computed: {
		resetActionText() {
			return 'next'
		},
		loginSecondaryText() {
			return (this.authenticatedEmail) ? 'resend?' : 'sign in'
		},
		loginSecondary() {
			return (this.authenticatedEmail) ? '/reset?resend=true' : '/login'
        },
        getBottomText() {
            return this.invalid ? 'Please enter at least 6 characters' : '6 characters or more'
		},
		getVerificationText() {
			return this.invalidCode ? 'Reset code validation failed. Please try again.' : 'We have verified your reset code. Please choose a new password.'
		},
		getLoadingText() {
			return this.resettingPassword ? 'Resetting your password...' : 'Confirming your reset code...'
		}
	}
}
</script>

<style scoped lang="scss">
@import "style.scss";
</style>
